import { createSlice } from "@reduxjs/toolkit";

const initialAppointmentsState = {
    currentpage: 1,
    currentpagedata: null,
    listFiltersParams: null,
    filters: {
        // case_status: null,
        // case_type: null,
        // location: null,
        // practice: null,
        // year: null
    },
    pageResults: null,
    isAPracticeUsedAsFilter: null,
    snapshotData: null,
    snapshotDataVerification: null,
    orderFilters: null,
    loading: false,
    refreshApi: 0,
    requesterId: null,
}

const appointmentsSlice = createSlice({
    name: 'appointments',
    initialState: initialAppointmentsState,
    reducers: { 
        setCurrentPage(state, data) {
            state.currentpage = data.payload
        },
        setCurrentPageData(state, data) {
            state.currentpagedata = data.payload
        },
        saveListFiltersParams(state, data) {
            state.listFiltersParams = data.payload
        },
        setFilters(state, data) {
            state.filters[data.payload.filter] = data.payload.value
        },
        setFiltersMultiple(state, data) {
            state.filters = data.payload
        },
        removeSingleFilter(state, data) {
            if (!data.payload.multiple) { // if its not for a multiple selection, simply remove
                state.filters[data.payload.filter] = null
            } else { // multiple selection!!!
                const itemIndex = state.filters[data.payload.filter].findIndex(object => {
                    return object.value == data.payload.value                  
                })

                if (itemIndex !== -1) {
                    if (state.filters[data.payload.filter].length == 1) {
                        state.filters[data.payload.filter] = null
                    } else {
                        state.filters[data.payload.filter].splice(itemIndex, 1)
                    }      
                    
                }
            }
            // state.filters[data.payload.filter] = null
        },
        clearFilters(state) {
            state.filters = {
                case_status: null,
                case_type: null,
                location: null,
                practice: null,
                year: null
            }
        },
        setPageResults(state, data) {
            state.pageResults = data.payload
        },
        setIsAPracticeUsedAsFilter(state, data) {
            state.isAPracticeUsedAsFilter = data.payload
        },
        setSnapshotData(state, data) {
            state.snapshotData = data.payload
        },
        setSnapshotDataVerification(state, data) {
            state.snapshotDataVerification = data.payload
        },
        setSnapshotDataGeneral(state, data) {
            state.snapshotDataGeneral = data.payload
        },
        setOrderFilters(state, data) {
            state.orderFilters = data.payload
        },
        setMasterLoading(state, data) {
            state.loading = data.payload
        },
        setRefreshApi(state) {
            state.refreshApi = state.refreshApi + 1
        },
        setRequesterId(state, data) {
            state.requesterId = data.payload
        }
    }
})

export const appointmentsActions = appointmentsSlice.actions

export default appointmentsSlice.reducer